import React from "react";
import { getLeagueStats } from "./handlers/leagueStats";
import { getPlayerData } from "./handlers/playerHandlers";
import { getTeamData } from "./handlers/teamHandlers";
import { getMatchOrLeagueUrl } from "./handlers/urlMap";

export const getData = async ({
  dataId,
  dataType,
  baseUrl,
  sport,
  date,
  type = "all",
  difference,
  leagueId,
  country = "PAK",
}) => {
  const headers = {
    Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
    country,
    difference,
  };

  try {
    // Special cases
    if (dataType === "league-stats") {
      return await getLeagueStats({ baseUrl, sport, dataId, headers });
    }

    // This component will work with football Team Api's and TEAM Head for All sports
    if (dataType.startsWith("team-") || dataType === "team") {
      return await getTeamData({ baseUrl, sport, dataId, headers, dataType, leagueId });
    }
    // This component will work with football Player Api's and PLAYER Head for All sports
    if (dataType.startsWith("player-") || dataType === "player") {
      return await getPlayerData({ baseUrl, sport, dataId, headers, dataType });
    }

    // Cricket player handlers
    if (dataType.startsWith("cricket-player-")) {
      return await getPlayerData({ baseUrl, sport, dataId, headers, dataType });
    }

    // URL mapped cases
    const url = getMatchOrLeagueUrl({ dataType, dataId, sport, baseUrl, date, type, leagueId });
    if (!url) throw new Error("Invalid data type");

    const res = await fetch(url, { next: { revalidate: 0 }, headers });
    if (!res.ok) throw new Error(`API Fails at: ${url} (Status: ${res.status})`);
    console.log("API Runs at:", url);
    return await res.json();
  } catch (error) {
    console.error("Error fetching data:", error);
    return null;
  }
};

